<template>
  <main>
    <div class="container">
      <div class="row">
        <div class="col-full">
          <h1 class="heading-xl align-center-space-between" data-test="support-page-heading">
            {{ $t('support.heading') }}
          </h1>
        </div>
      </div>
      <div class="row">
        <div class="col-full">
          <al-list card class="margin-bottom-sm">
            <al-list-item
              v-analytics:click="$EVENTS.FREQUENTLY_ASKED_QUESTIONS_SUPPORT"
              wrap
              name="faq-section"
              @click="$router.push({ name: ROUTES.FAQ })">
              <al-icon-text icon="icon-faqs" variant="sm" name="faq-section-header">
                <p>{{ $t('support.faq.heading') }}</p>
              </al-icon-text>
            </al-list-item>
          </al-list>
          <al-list card>
            <al-list-item wrap name="get-support-section">
              <al-icon-text icon="icon-support" variant="sm" name="get-support-section-header">
                <p>{{ $t('support.contactUs.heading') }}</p>
              </al-icon-text>
              <i18n path="support.contactUs.subheading" tag="p">
                <a
                  :href="customerServiceContact.href"
                  place="customerServiceNumber"
                  class="no-wrap"
                  >{{ customerServiceContact.val }}</a
                >
              </i18n>
            </al-list-item>
          </al-list>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import { AlIconText, AlList, AlListItem } from '@mc-alberta/alcapone'
import { mapState } from 'vuex'
import { ROUTES } from '@/constants.js'

export default {
  name: ROUTES.SUPPORT,
  components: { AlIconText, AlList, AlListItem },
  data() {
    return {
      ROUTES
    }
  },
  computed: {
    ...mapState({
      firstName: (state) => state.user.consumer.firstName,
      currentCountry: (state) => state.user.consumer.countryCode
    }),
    customerServiceContact() {
      const countryConfig = this.$i18nData.getCountryConfig(this.currentCountry)
      const phoneNumber = countryConfig?.customerSupportPhoneNumber || ''
      const email = countryConfig?.customerSupportEmail || ''

      if (email) {
        return {
          href: `mailto:${email}`,
          val: email
        }
      } else {
        return {
          href: `tel:${phoneNumber}`,
          val: phoneNumber
        }
      }
    }
  }
}
</script>
